import { render, staticRenderFns } from "./ContentLenderBox.vue?vue&type=template&id=8be6dd42&"
import script from "./ContentLenderBox.vue?vue&type=script&lang=js&"
export * from "./ContentLenderBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports